export async function printOneDayVacancyImpl (vm, oneDayVacancyId) {
  let result = await vm.$postToBackend('/createOneDayVacancyPrint', { oneDayVacancyId })

  let backgroundFunctionId = result.backgroundFunctionId
  let fileName = result.tmpOutput

  window.checkDownloadStatusAndOpenFile(`/checkStatusOfOneDayVacancyPrint?backgroundFunctionId=${backgroundFunctionId}&fileName=${fileName}&oneDayVacancyId=${oneDayVacancyId}`)
}
